<template>
    <div class="add">
        <div class="addHead el-row--flex">
            <el-button size="mini" @click="add(2)">
                <i class="el-icon-plus"></i>
                个人用户
            </el-button>
            <el-button size="mini" @click="add(1)">
                <i class="el-icon-plus"></i>
                企业用户
            </el-button>
        </div>
        <el-form
            :inline="true"
            size="mini"
            :model="filter"
            class="demo-form-inline"
        >
            <el-form-item label="用户名称">
                <el-input v-model="filter.userName"></el-input>
            </el-form-item>
            <el-form-item label="用户类型">
                <el-select v-model="filter.userType">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="企业" value="1"></el-option>
                    <el-option label="个人" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="filter.userPhone"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" height="718" size="mini" :border="true">
            <el-table-column label="序号" type="index" min-width="64">
            </el-table-column>
            <el-table-column min-width="100" label="用户名称">
                <template slot-scope="scope">
                    {{ scope.row.userName }}
                </template>
            </el-table-column>
            <el-table-column label="用户类型">
                <template slot-scope="scope">
                    {{ scope.row.userType == 1 ? "企业" : "个人" }}
                </template>
            </el-table-column>
            <el-table-column label="实名状态">
                <template slot-scope="scope">
                    {{ scope.row.authType == 1 ? "已实名" : "未实名" }}
                </template>
            </el-table-column>
            <el-table-column label="手机号码">
                <template slot-scope="scope">
                    {{ scope.row.userPhone }}
                </template>
            </el-table-column>
            <!-- <el-table-column
        label="是否实名">
        <template slot-scope="scope">
          {{ scope.row.authType == 1 ? '是' : '否' }}
        </template>
      </el-table-column> -->
            <el-table-column min-width="120" label="编号">
                <template slot-scope="scope">
                    {{ scope.row.certifyNum }}
                </template>
            </el-table-column>
            <el-table-column label="代表人">
                <template slot-scope="scope">
                    {{ scope.row.artificialPersion }}
                </template>
            </el-table-column>
            <el-table-column width="120px" label="操作">
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="mini" @click="edit(scope.row)" >修改</el-button> -->
                    <el-button type="text" size="mini" @click="del(scope.row.contractUserId)" >删除</el-button>
                    <el-button
                        v-if="
                            scope.row.userType != 2 &&
                            scope.row.certificateAgree != 1
                        "
                        type="primary"
                        :disabled="scope.row.countSecond != 0"
                        size="mini"
                        @click="msg(scope.row.contractUserId)"
                        >发送短信{{
                            scope.row.countSecond == 0
                                ? ""
                                : scope.row.countSecond
                        }}</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="tableDataLength"
            @current-change="pageChange"
            @size-change="handleSizeChange"
        ></el-pagination>
        <el-dialog
            :title="isUpdate ? '个人用户' : '企业用户'"
            :visible.sync="addShow"
            width="600px"
            :before-close="addClose"
            @close="addClose"
        >
            <el-form
                :model="addParam"
                size="mini"
                :rules="addRule"
                ref="add"
                label-width="80px"
            >
                <el-row v-if="addParam.userType == 2">
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="userName">
                            <el-input
                                v-model="addParam.userName"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="userPhone">
                            <el-input
                                v-model="addParam.userPhone"
                                maxlength="11"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="addParam.userType == 1">
                    <el-col :span="12">
                        <el-form-item label="企业法人" prop="artificialUserId">
                            <el-select
                                v-model="addParam.artificialUserId"
                                filterable
                                remote
                                placeholder="请查询企业法人"
                                @change="firstChange"
                                :remote-method="searchFirst"
                                :loading="searchloading"
                            >
                                <el-option
                                    v-for="item in firstList"
                                    :key="item.contractUserId"
                                    :label="item.userName"
                                    :value="item.contractUserId"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
            <el-form-item label="企业法人" prop="artificialUserId">
              <el-select v-model="addParam.artificialUserId" placeholder="请选择">
                <el-option v-for="(item, index) in personList" :key="index" :label="item.userName" :value="item.contractUserId"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
                    <el-col :span="12">
                        PS：创建企业用户前，请先创建法人的个人用户
                    </el-col>
                </el-row>
                <el-row v-if="addParam.userType == 1">
                    <el-col :span="12">
                        <el-form-item label="经办人" prop="brokerId">
                            <el-select
                                v-model="addParam.brokerId"
                                filterable
                                remote
                                placeholder="请查询经办人"
                                @change="secondChange"
                                :remote-method="searchSecond"
                                :loading="searchloading"
                            >
                                <el-option
                                    v-for="item in secondList"
                                    :key="item.contractUserId"
                                    :label="item.userName"
                                    :value="item.contractUserId"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
            <el-form-item label="经办人" prop="brokerId">
              <el-select v-model="addParam.brokerId" placeholder="请选择">
                <el-option v-for="(item, index) in personList" :key="index" :label="item.userName" :value="item.contractUserId"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
                    <el-col :span="12">
                        PS：创建企业用户前，请先创建经办人的个人用户
                    </el-col>
                </el-row>
                <el-form-item
                    label="企业名称"
                    prop="userName1"
                    v-if="addParam.userType == 1"
                >
                    <el-input
                        v-model="addParam.userName1"
                        placeholder="请输入企业名称"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="税号"
                    prop="certifyNum"
                    v-if="addParam.userType == 1"
                >
                    <el-input
                        v-model="addParam.certifyNum"
                        maxlength="19"
                        placeholder="请输入税号"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="身份证号"
                    prop="certifyNum1"
                    v-if="addParam.userType == 2"
                >
                    <el-input
                        v-model="addParam.certifyNum1"
                        maxlength="19"
                        placeholder="请输入身份证号"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addShow = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            addType: "",
            addShow: false,
            isUpdate: false,
            personList: [],
            firstList: [],
            secondList: [],
            addParam: {
                userType: "",
                userName: "",
                userName1: "",
                userPhone: "",
                certifyNum: "",
                certifyNum1: "",
                artificialUserId: "",
                brokerId: "",
            },
            addRule: {
                userName: [
                    {
                        required: true,
                        message: "请输入用户名称",
                        trigger: "change",
                    },
                ],
                userName1: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: "change",
                    },
                ],
                userPhone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "change",
                    },
                    {
                        min: 11,
                        message: "请输入正确的手机号",
                        trigger: "change",
                    },
                ],
                certifyNum: [
                    {
                        required: true,
                        message: "请输入税号",
                        trigger: "change",
                    },
                    { min: 18, message: "请输入正确的税号", trigger: "change" },
                ],
                certifyNum1: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "change",
                    },
                    {
                        min: 18,
                        message: "请输入正确的身份证号",
                        trigger: "change",
                    },
                ],
                artificialUserId: [
                    {
                        required: true,
                        message: "请输入法定代表人",
                        trigger: "change",
                    },
                ],
            },
            currentPage: 1,
            tableDataLength: 0,
            pageSize: "10",
            filter: {
                userName: "",
                userType: "",
                userPhone: "",
                authType: "",
            },
            tableData: [],
            countArr: [],
        };
    },
    mounted() {
        this.refresh();
    },
    methods: {
        add(type) {
            this.addParam = {
                userType: type,
                userName: "",
                userName1: "",
                userPhone: "",
                certifyNum: "",
                certifyNum1: "",
                artificialUserId: "",
                brokerId: "",
            };
            this.isUpdate = true;
            this.addType = type;
            this.addShow = true;
        },
        edit(row) {
            this.addShow = true;
            console.log(row, "1111");
            this.addType = row.userType;
            this.addParam = row;
        },
        // openEdit(row) {
        //   this.isUpdate = row.insuranceId ? true : false
        //   if (this.isUpdate) {
        //     for (let key in this.addParam) {
        //       this.addParam[key] = row[key]
        //     }
        //     this.addParam.insuranceId1 = row.insuranceId
        //     this.addParam.insuranceId = row.insuranceId
        //     this.insuranceChange(row.insuranceId)
        //   }
        //   this.addShow = true
        // },

        addClose() {
            this.addShow = false;
        },
        searchFirst(keyword) {
            this.searchId(keyword, "first");
        },
        searchSecond(keyword) {
            this.searchId(keyword, "second");
        },
        searchId(keyword, type) {
            this.searchloading = true;
            this.$global.axios.post(
                this,
                "/sywl/api/contractUser/getContractUserList",
                {
                    keyword: keyword,
                },
                (res) => {
                    this.searchloading = false;
                    this[type + "List"] = res.data;
                }
            );
        },
        firstChange(e) {
            this.firstList.forEach((ele) => {
                if (ele.contractUserId == e) {
                    this.addParam.signFirstName = ele.userName;
                }
            });
        },
        secondChange(e) {
            this.secondList.forEach((ele) => {
                if (ele.contractUserId == e) {
                    this.addParam.signSecondName = ele.userName;
                }
            });
        },

        save() {
            this.$refs["add"].validate((valid) => {
                if (valid) {
                    this.$global.axios.post(
                        this,
                        "/sywl/api/eqb/contractUser/add",
                        {
                            jsonStr: JSON.stringify(
                                this.addParam.userType == 2
                                    ? {
                                          userType: this.addParam.userType,
                                          userName: this.addParam.userName,
                                          userPhone: this.addParam.userPhone,
                                          certifyNum: this.addParam.certifyNum1,
                                      }
                                    : {
                                          userType: this.addParam.userType,
                                          artificialUserId:
                                              this.addParam.artificialUserId,
                                          brokerId: this.addParam.brokerId,
                                          userName: this.addParam.userName1,
                                          certifyNum: this.addParam.certifyNum,
                                      }
                            ),
                        },
                        (res1) => {
                            this.$global.goPay(this, res1.data, (res) => {
                                this.$message.success("维护成功");
                                location.reload();
                            });
                        }
                    );
                }
            });
        },
        msg(id) {
            this.$global.axios.post(
                this,
                "/sywl/api/eqb/contractUser/sendMess",
                {
                    contractUserId: id,
                },
                (res) => {
                    this.$message.success("发送成功");
                },
                (res) => {},
                (res) => {
                    let tableIndex;
                    this.tableData.forEach((ele, index) => {
                        if (id == ele.contractUserId) {
                            tableIndex = index;
                        }
                    });
                    const ind = this.countArr.length;
                    this.tableData[tableIndex].countSecond = 60;
                    const that = this;
                    this.countArr[ind] = setInterval(() => {
                        that.tableData[tableIndex].countSecond--;
                        if (that.tableData[tableIndex].countSecond == 0)
                            clearInterval(that.countArr[ind]);
                    }, 1000);
                }
            );
        },
        del(id) {
            this.$global.axios.post(
                this,
                "/sywl/api/eqb/contractUser/delUser",
                {
                    contractUserId: id,
                },
                (res) => {
                    this.$message.success("删除成功");
                    location.reload();
                },
               
            );
        },
        refresh() {
            let data = this.filter;
            data.pageNo = this.currentPage;
            data.pageSize = this.pageSize;
            this.$global.axios.post(
                this,
                "/sywl/api/contractUser/list",
                data,
                (res) => {
                    res.data.records.forEach((ele) => {
                        ele.countSecond = 0;
                    });
                    this.tableData = res.data.records;
                    this.tableDataLength = Number(res.data.total);
                }
            );
        },
        pageChange(t) {
            this.currentPage = t;
            this.refresh();
        },
        handleSizeChange(n) {
        this.pageSize= n;
        this.refresh();
      },
        onSubmit() {
            this.currentPage = 1;
            this.refresh();
        },
    },

    watch: {
        addType(n) {
            this.addParam.userType = this.addType;
            this.isUpdate = n == 2 ? true : false;
            if (n == 1) {
                this.$global.axios.post(
                    this,
                    "/sywl/api/contractUser/getPersonUserList",
                    {},
                    (res) => {
                        this.personList = res.data;
                    }
                );
            }
        },
        addShow(n) {
            if (!n) {
                this.$refs["add"].clearValidate();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    padding: 12px 16px;
    background-color: #fff;

    & /deep/ .el-dialog__header {
        background-color: #000;
        text-align: left;
        color: #fff;

        .el-dialog__title {
            color: #fff;
        }
    }

    & /deep/ .el-dialog__body {
        padding: 20px;

        .el-form {
            text-align: left;
        }
    }

    &Head {
        .el-button {
            margin-bottom: 20px;
            border-color: #1875f0;
            color: #1875f0;
        }
    }

    & /deep/ > .el-form {
        text-align: left;

        .el-select {
            width: 80px;
        }
    }

    & /deep/ .el-table {
        .el-table__cell {
            font-size: 12px;
            text-align: center;
        }
    }

    .el-pagination {
        margin-top: 20px;
        text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/service/defend.vue